export default {
  'billingSubscriptionPayments.description':
    'Review pending manual subscription payments and subscriptions that need billing attention.',
  'billingSubscriptionPayments.claim.message': 'Register a manual subscription payment?',
  'billingSubscriptionPayments.claim.hint':
    'Report the amount received, payment date, and external reference. Currency and tax are set by AUTOMY on review.',
  'billingSubscriptionPayments.claim.submit': 'Submit',
  'billingSubscriptionPayments.claim.lockedTitle':
    'This payment was already reported and is under review.',
  'billingSubscriptionPayments.claim.evidencePlaceholder': 'Optional document id',
  'billingSubscriptionPayments.claim.action': 'Register payment',
  'billingSubscriptionPayments.review.confirm.message': 'Confirm this manual payment?',
  'billingSubscriptionPayments.review.reject.message': 'Reject this payment claim?',
  'billingSubscriptionPayments.review.confirm': 'Confirm payment',
  'billingSubscriptionPayments.review.reject': 'Reject claim',
  'billingSubscriptionPayments.review.reject.reasonPlaceholder':
    'Explain why this payment claim is rejected.',
  'billingSubscriptionPayments.review.discrepancyAck':
    'I acknowledge that the confirmed gross differs from the reported gross. Both values will remain visible.',
  'billingSubscriptionPayments.fields.provider': 'Provider',
  'billingSubscriptionPayments.fields.grossAmount': 'Reported gross amount',
  'billingSubscriptionPayments.fields.reportedGrossAmount': 'Reported gross',
  'billingSubscriptionPayments.fields.reportedPaymentDate': 'Reported payment date',
  'billingSubscriptionPayments.fields.reportedExternalReference': 'Reported reference',
  'billingSubscriptionPayments.fields.externalReference': 'External reference',
  'billingSubscriptionPayments.fields.evidenceDocumentId': 'Evidence document',
  'billingSubscriptionPayments.fields.notes': 'Notes',
  'billingSubscriptionPayments.fields.baseNetAmount': 'Base before discount',
  'billingSubscriptionPayments.fields.discountAmount': 'Discount',
  'billingSubscriptionPayments.fields.discountAssignmentId': 'Discount assignment',
  'billingSubscriptionPayments.fields.mrrAmount': 'MRR',
  'billingSubscriptionPayments.fields.noDiscount': 'This charge had no discount.',
  'billingSubscriptionPayments.sections.discountSnapshot': 'Discount frozen on the payment',
  'billingSubscriptionPayments.fields.netAmount': 'Confirmed net (subtotal)',
  'billingSubscriptionPayments.fields.taxAmount': 'Confirmed tax',
  'billingSubscriptionPayments.fields.confirmedGrossAmount': 'Confirmed gross (total)',
  'billingSubscriptionPayments.fields.effectivePaymentDate': 'Effective payment date',
  'billingSubscriptionPayments.fields.providerTaxReference': 'Tax authority reference',
  'billingSubscriptionPayments.fields.rejectionReason': 'Rejection reason',
  'billingSubscriptionPayments.columns.company': 'Company',
  'billingSubscriptionPayments.columns.plan': 'Plan',
  'billingSubscriptionPayments.columns.netAmountDue': 'Net due',
  'billingSubscriptionPayments.columns.dueDate': 'Due date',
  'billingSubscriptionPayments.columns.lastPaymentStatus': 'Last payment',
  'billingSubscriptionPayments.columns.reportedReference': 'Reported reference',
  'billingSubscriptionPayments.columns.confirmedReference': 'Confirmed reference',
  'billingSubscriptionPayments.sections.reported': 'Reported claim',
  'billingSubscriptionPayments.sections.confirmed': 'Confirmed payment',
  'billingSubscriptionPayments.tax.calculatedAtCheckout': 'Calculated at checkout',
  'billingPaymentProviderType.stripe': 'Stripe',
  'billingPaymentProviderType.bankTransfer': 'Bank transfer',
  'billingPaymentProviderType.manual': 'Manual',
  'billingPaymentTransactionStatus.pending': 'Pending',
  'billingPaymentTransactionStatus.requiresAction': 'Requires action',
  'billingPaymentTransactionStatus.processing': 'Processing',
  'billingPaymentTransactionStatus.paid': 'Paid',
  'billingPaymentTransactionStatus.failed': 'Failed',
  'billingPaymentTransactionStatus.cancelled': 'Cancelled',
  'billingPaymentTransactionStatus.refunded': 'Refunded',
  'billingPaymentTransactionStatus.partiallyRefunded': 'Partially refunded',
  'global.text.billingSubscriptionPayments': 'Subscription payments',
  'global.text.subscriptionSubtotal': 'Subscription subtotal (before tax)',
  'configList.hero.resource.billingSubscriptionPayments': 'subscription payments needing attention',
  'configForm.hero.summary.resource.billingSubscriptionPayments.details':
    'of the selected subscription payment',
};
